/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EntityModelResponseContainerProgramNotificationConfigurationDto } from '../models/EntityModelResponseContainerProgramNotificationConfigurationDto';
import type { ProgramNotificationConfigurationDto } from '../models/ProgramNotificationConfigurationDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProgramNotificationConfigurationControllerService {
    /**
     * @returns EntityModelResponseContainerProgramNotificationConfigurationDto OK
     * @throws ApiError
     */
    public static read({
        type,
    }: {
        type: 'NOTIFICATION' | 'FULLSCREEN',
    }): CancelablePromise<EntityModelResponseContainerProgramNotificationConfigurationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/program/notification-configuration/{type}',
            path: {
                'type': type,
            },
        });
    }
    /**
     * @returns EntityModelResponseContainerProgramNotificationConfigurationDto OK
     * @throws ApiError
     */
    public static update({
        type,
        requestBody,
    }: {
        type: 'NOTIFICATION' | 'FULLSCREEN',
        requestBody: ProgramNotificationConfigurationDto,
    }): CancelablePromise<EntityModelResponseContainerProgramNotificationConfigurationDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/program/notification-configuration/{type}',
            path: {
                'type': type,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
